import axios from 'components/Axios';
import { Skills } from '../APIEndPoint';

const AddSkills = (payload) => {
  const promise = axios.post(`${Skills}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const UpdateSkills = (payload, data) => {
  const promise = axios.put(`${Skills}/${data.id}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetPostById = () => {
  const getUsername = window.location.pathname.split('/');
  const currentUsername = getUsername?.[getUsername?.length - 1]?.trim();
  const promise = axios.get(`${Skills}/byUserName/${currentUsername}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const DeleteSkills = (id) => {
  const promise = axios.delete(`${Skills}/${id}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export { AddSkills, UpdateSkills, GetPostById, DeleteSkills };
